// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-select[data-v-50159628]:deep(.v-input__slot){min-height:72px!important}", ""]);
// Exports
module.exports = exports;
